module.exports = __webpack_public_path__ + "static/media/kofab5.3ae07d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/kofab5.jpg
// module id = 203
// module chunks = 0